import React from "react";
import { InfiniteLoader, AutoSizer, Table, Column } from "react-virtualized";
import { useTable, useGroupBy, useExpanded, useFlexLayout, useSortBy } from "react-table";

import "react-virtualized/styles.css"; // only needs to be imported once
import "./VZenTable.scss";

interface IVZenTable {
  columns: any;
  data: any;
  initialState?: any;
  containerProps?: any;
  infiniteLoaderProps?: any;
  tableProps?: any;
  useTableProps?: any;
  sortBy?: string;
  sortDirection?: string;
}

export const TransactionVZenTable = ({
  columns,
  data,
  containerProps,
  infiniteLoaderProps,
  tableProps,
  useTableProps,
}: IVZenTable) => {
  const { headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
      ...useTableProps,
    },
    useGroupBy,
    useSortBy,
    useExpanded,
    useFlexLayout,
  );
  return (
    <div className='VZenTable' {...containerProps}>
      <InfiniteLoader {...infiniteLoaderProps}>
        {({ onRowsRendered, registerChild }) => (
          <AutoSizer defaultWidth={1000} defaultHeight={800}>
            {({ width, height }) => (
              <Table
                {...tableProps}
                ref={registerChild}
                onRowsRendered={(data) => {
                  onRowsRendered(data);
                  if (tableProps.onRowsRendered) {
                    tableProps.onRowsRendered(data);
                  }
                }}
                overscanRowCount={10}
                rowGetter={({ index }) => {
                  const row = rows[index];
                  prepareRow(row);
                  return row;
                }}
                rowCount={rows.length}
                height={height}
                width={width}
              >
                {headerGroups[0].headers.map((column: any, id: number) => (
                  <Column
                    key={`${column.id}-${id}`}
                    dataKey={column.id}
                    width={column.width}
                    flexGrow={column.flexGrow}
                    flexShrink={column.flexShrink}
                    style={column.style}
                    headerRenderer={() => {
                      return (
                        <div role='button' tabIndex={-1}>
                          {column.render("Header")}
                        </div>
                      );
                    }}
                    cellRenderer={({ columnIndex, rowData }) => rowData.cells[columnIndex].render("Cell")}
                  />
                ))}
              </Table>
            )}
          </AutoSizer>
        )}
      </InfiniteLoader>
    </div>
  );
};
